// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.cryptnox",
    name: "Cryptnox Wallet",
    homepage: "https://cryptnox.com",
    image_id: "2947b7c8-8966-4485-a98d-25fe43c16700",
    app: {
        browser: "https://cryptnox.com",
        ios: "https://apps.apple.com/app/id1583011693",
        android: "https://play.google.com/store/apps/details?id=com.cryptnox.cryptnoxwallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "cryptnox://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map